import { render, staticRenderFns } from "./StudentMappingTable.vue?vue&type=template&id=52236792&"
import script from "./StudentMappingTable.vue?vue&type=script&lang=js&"
export * from "./StudentMappingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports